export default __webpack_public_path__ + "static/media/vmechanic.b70b9723.png";